/* eslint-disable react/prop-types */
import { Box, Typography } from "@mui/material";
import { Formik } from "formik";
import React, { useContext, useEffect, useState } from "react";
// import { fetchIntroductionData } from "../../../../../redux/actions/introduction";
import * as Sentry from "@sentry/react";
import { prepareRemarkPayload } from "../../../../../utils";
import { debounce, isEmptyObj } from "../../../../../utils/helper";
import Button from "../../../Button";
import { CommonStyles } from "../../../Button/commonButtonStyle";
import InputField from "../../../InputField/InputField";
import Modal from "../../../Modal/Modal";
// import Dropdown from "../../Dropdown/Dropdown";
import RemarksList from "../../RemarksList/RemarksList";

import { fetchRemarks, getApi, getSeletedRowId, MODAL_TYPES } from "../utils";
import styles from "./styles";
import { AlertStatus } from "../../../../../contants";
import { ToastAlertContext } from "../../../../../config/providers/ToastAlert";

// const OS_OPTIONS = [
//   { key: "Yes", value: "yes" },
//   { key: "No", value: "no" },
// ];

function RejectModal({
  selectedRow,
  open,
  onClose,
  cameFromFriendTransfer,
  cameFromMemberTransfer,
  refreshTransferList,
}) {
  const [remarks, setRemarks] = useState([]);
  const toast = useContext(ToastAlertContext);

  const getTitle = () => {
    if (cameFromFriendTransfer) {
      return "Reject Friend";
    }
    if (cameFromMemberTransfer) {
      return "Reject Member ";
    }
    return "Reject Introduction ";
  };

  const onReject = async (payload) => {
    try {
      const { remark } = payload;
      if (!remark || !remark.length) throw new Error("Please add remark");

      const body = prepareRemarkPayload(remark);
      // get api things
      const { api, apiName, apiPayload } = getApi({
        cameFromMemberTransfer,
        cameFromFriendTransfer,
        selectedRow,
        modalType: MODAL_TYPES.REJECT,
        body,
      });
      // calling api
      await api[apiName](apiPayload);

      // success
      toast.show("Rejected Successfully", AlertStatus.SUCCESS);
      setTimeout(() => {
        onClose();
        refreshTransferList();
      }, 2000);
    } catch (error) {
      toast.show(error.message, AlertStatus.ERROR);
      Sentry.captureException(error);
    }
  };

  useEffect(() => {
    if (!isEmptyObj(selectedRow)) {
      const id = getSeletedRowId(selectedRow);
      fetchRemarks({
        cameFromFriendTransfer,
        cameFromMemberTransfer,
        id,
        setRemarks,
      });
    }
  }, [cameFromFriendTransfer, cameFromMemberTransfer, selectedRow]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      customStyle={{ minWidth: "25%", minHeight: "30%" }}
    >
      <div>
        <Formik
          enableReinitialize
          initialValues={{
            isBelongToSameStructure: "no",
          }}
          onSubmit={debounce((values) => {
            const dataToSend = { ...values };
            onReject(dataToSend);
          })}
        >
          {({ handleSubmit, handleChange, values }) => (
            <>
              <Box style={{ paddingBottom: "5px" }}>
                <Typography
                  style={{
                    color: "#8C8C8C",
                    fontSize: "20px ",
                    fontWeight: "500",
                  }}
                >
                  {getTitle()}
                </Typography>
              </Box>
              {/* <Box
                display="flex"
                flexDirection="row"
                justifyContent="flex-end"
                padding="15px 0px 15px 0px"
              >
                <Box style={{ width: "300px", color: "#8C8C8C" }}>
                  <Typography>
                    {" "}
                    Does above introduction belong to your structure?
                  </Typography>
                </Box>
                <div style={styles.mediumItem}>
                  <Dropdown
                    name="isBelongToSameStructure"
                    value={values.isBelongToSameStructure}
                    options={OS_OPTIONS}
                    onChange={handleChange}
                    style={{
                      width: "100%",
                    }}
                  />
                </div>
              </Box> */}
              <div style={{ marginTop: "20px" }}>
                <InputField
                  type="text"
                  key="remark"
                  name="remark"
                  required
                  label="Enter your remark here..."
                  style={styles.inputStyle}
                  value={values.remark}
                  onChange={handleChange}
                  InputProps={{ sx: { minHeight: "91px" } }}
                />
                <div>
                  <RemarksList remarks={remarks} />
                </div>
              </div>
              <div style={{ display: "flex", gap: 10, marginTop: "20px" }}>
                <Button
                  variant="contained"
                  style={CommonStyles.buttonStyle}
                  onClick={handleSubmit}
                  type="submit"
                  label="REJECT"
                />
                <Button
                  variant="outlined"
                  style={{
                    ...CommonStyles.buttonStyle,
                  }}
                  onClick={onClose}
                  label="CANCEL"
                />
              </div>
            </>
          )}
        </Formik>
      </div>
    </Modal>
  );
}

export default RejectModal;
